import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-[500px] mx-auto py-6" }
const _hoisted_2 = { class: "col-span-2" }
const _hoisted_3 = { class: "flex items-center justify-end w-full space-x-3" }

import { ref, onMounted } from 'vue';
import UserLayout from '@/layouts/UserLayout.vue';
import FormSection from './FormSection.vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';

import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import SuccessModal from '@/components/modals/SuccessModal.vue';

import { useRoute, useRouter } from "vue-router";

import { errorResponse } from "@/helpers/errorMessage";

import pickBy from "lodash/pickBy";
import assignValues from "@/helpers/assignValues"

import FormOptions from '@/classes/Settings/FormOptions'


export default /*#__PURE__*/_defineComponent({
  __name: 'EditPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const loading = ref<boolean>(false);
const errors = ref<any>();

const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);

// const option: string = route.params.option;

const form = ref<{
    id: number,
    name: string,
    type: string,
}>({
    id: parseInt(route.params.id),
    name: '',
    type: route.params.option
});

const back = (): void => {
    router.replace(`/settings/form-options/view/${form.value.type}`)
}


const init = (): void => {
    loading.value = true;

    FormOptions.edit(form.value.type, form.value.id, pickBy(form.value))
        .then(({ data }) => {
            form.value = assignValues(form.value, data.item);
            loading.value = false;
        })
        .catch((error: any) => {
           console.log(error);
        });
}


const save = (): void => {
    loading.value = true;

    FormOptions.update(form.value.type, form.value.id, pickBy(form.value))
        .then((response: any) => {
            loading.value = false;
            showSuccess.value = true;
            showConfirmation.value = false

           
        })
        .catch((error: any) => {
            loading.value = false;
            showConfirmation.value = false
            errors.value = errorResponse(error.response?.data?.errors)
        });
}

onMounted(() => {
    init()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: true,
    backLink: "/settings/form-options/view"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FormSection, {
          form: form.value,
          errors: errors.value
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
                }, [
                  _createVNode(ButtonComponent, { btnWidth: "quinary" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Cancel")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(ButtonComponent, {
                  btnWidth: "primary",
                  onClick: save
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Save Changes")
                  ]),
                  _: 1
                })
              ]),
              _createVNode(ConfirmationModal, {
                typeTwo: true,
                show: showConfirmation.value,
                onCancel: _cache[1] || (_cache[1] = ($event: any) => (showConfirmation.value = false)),
                onConfirm: _cache[2] || (_cache[2] = ($event: any) => {showSuccess.value = true; showConfirmation.value = false}),
                "cancel-text": "Cancel",
                "action-text": "Confirm",
                title: "Save Record",
                content: "Are you sure you wish to save this record?"
              }, null, 8, ["show"]),
              _createVNode(SuccessModal, {
                show: showSuccess.value,
                onConfirm: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).replace(`/settings/form-options/view/${form.value.type}`))),
                "action-text": "Close",
                title: "Record Updated!",
                content: "Data has been successfully updated"
              }, null, 8, ["show"])
            ])
          ]),
          _: 1
        }, 8, ["form", "errors"])
      ])
    ]),
    _: 1
  }))
}
}

})